import useFonts from './useFonts'

export * from './useFonts'
export default useFonts
